import { render } from "./ConfigurationPanelTabContentItem.vue?vue&type=template&id=7ef88460&scoped=true"
import script from "./ConfigurationPanelTabContentItem.vue?vue&type=script&lang=ts"
export * from "./ConfigurationPanelTabContentItem.vue?vue&type=script&lang=ts"

import "./ConfigurationPanelTabContentItem.vue?vue&type=style&index=0&id=7ef88460&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-7ef88460"

export default script